export default "__VITE_ASSET__IEWfQUYR__"